import {Button as AntButton, Modal, Select} from 'antd';
import { useTranslation } from 'react-i18next';
import { IStudent, IStudentAttendChange } from '../../../../models/students.model';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/rootReducer';
import { useEffect, useState } from 'react';
import moment from 'moment';
import useAxios from '../../../../hooks/useAxios';
import { updateRollbook } from '../../../../api/campusClasses3.api';
import useNotification from '../../../../hooks/useNotification';

interface IProps {
    visible: boolean;
    setVisible: (visible: boolean) => void;
    attChangeValues: IStudentAttendChange;
    student: IStudent | undefined;
    fnReload: () => void;
}

const { Option } = Select;

const ChangeAttendanceModal = ({visible, setVisible, attChangeValues, student, fnReload}: IProps) => {

    const { t, i18n } = useTranslation();
    const { commonCodes } = useSelector((state: RootState) => state.commonCode);
    // CL0001 = 출결 상태
    const CL0001 = commonCodes.find((item) => item.commonCode === 'CL0001')?.detailCode;
    const [attStatus, setAttStatus] = useState(attChangeValues.attendStatus);
    const [attMemo, setAttMemo] = useState('');
    const { successNotification } = useNotification();

    const { data: updateData, isLoading: updateIsLoading, error: updateError, execute: updateExecute } = useAxios();

    useEffect(() => {
        
        if(attChangeValues.memo) {
            setAttMemo(attChangeValues.memo);
        } else {
            setAttMemo('');
        }

        setAttStatus(attChangeValues.attendStatus || 'AT');
    }, [visible]);

    useEffect(() => {
        if (updateData && !updateIsLoading) {
          successNotification(t('common.message.save1'));
          fnReload();
          setVisible(false);
        }
    }, [updateData, updateIsLoading]);

    const onSave = () => {
        if (!attChangeValues.classStudentCode || !student?.studentCode || !attChangeValues.timetableCode) return;

        const tAttendCode: any = attChangeValues.attendCode;
        const tStudentCode: any = student?.studentCode;
        const tAttStatus: any = attStatus;
        const tTimetableCode: string = attChangeValues.timetableCode.toString();
        const req = [
            {
              attendCode: tAttendCode,
              classStudentCode: attChangeValues.classStudentCode,
              studentCode: tStudentCode,
              attendStatus: tAttStatus,
              memo: attMemo,
            },
        ];

        updateExecute(updateRollbook(attChangeValues.classCode, tTimetableCode, req));
    }

    return(
        <Modal
            title={t('student.attendance.title1')}
            width={750}
            open={visible}
            onCancel={() => setVisible(false)}
            footer={[
            <div className='comm-btn__area justify-content-center'>
                <AntButton
                    className='btn-basic pink'
                    onClick={onSave}
                >
                {t('common.button.save')}
                </AntButton>
                <AntButton key="cancel" className='btn-basic gray' onClick={() => setVisible(false)}>
                {t('common.button.close')}
                </AntButton>
            </div>
            ]}
        >
            <div className="comm-bx__space">
                <div><h3 className="sub-title">{attChangeValues.className}</h3></div>
            </div>
            <div className='comm-table__area line-type mt-0'>
                <table>
                    <thead>
                        <tr>
                            <th>{t('common.column.date')}</th>
                            <th>{t('class.class.column74')}</th>
                            <th>{t('class.class.column39')}</th>
                            <th>{t('class.class.column44')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{moment(attChangeValues.timetableDate).format('YYYY.MM.DD')}</td>
                            <td>{student?.studentKorName + '(' + student?.studentEngName + ')'}</td>
                            <td>
                                <Select
                                    className="w-100"
                                    placeholder={t('common.button.select')}
                                    value={attStatus}
                                    onChange={(value: string) => setAttStatus(value)}
                                >
                                    {CL0001?.map((item: any) => {
                                        return (
                                        <Option key={item.detailCode} value={item.detailCode}>
                                            {i18n.language === 'ko' ? item.korName : item.engName}
                                        </Option>
                                        );
                                    })}
                                </Select>

                            </td>
                            <td>
                            <input
                                type="text"
                                className="form-control input-text"
                                value={attMemo}
                                onChange={(e) => setAttMemo(e.target.value)}
                            />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </Modal>
    );
}

export default ChangeAttendanceModal;